<div
  id="{{ anchor }}"
  class="flex flex-col lg:flex-row"
  [class.lg:flex-row-reverse]="this.imagePosition === this.IMAGE_POSITION_RIGHT"
>
  <div class="relative w-full lg:w-8/12">
    <div
      class="absolute z-10 top-0 bottom-0 left-0 right-0 w-full h-full flex items-center bg-black opacity-25"
    ></div>
    <div class="w-full h-full absolute top-0 bottom-0 left-0 right-0">
      <img
        class="w-full h-full object-cover"
        *ngIf="image"
        [src]="image.url"
        alt="Hero image"
      />
    </div>
    <div class="relative z-20 lg:flex lg:flex-col lg:justify-center h-full py-20 text-center">
      <h2 class="mb-8 font-accent font-bold text-white text-4.5xl lg:text-5.8xl leading-10">
        {{ textOnImage }}
      </h2>
      <div class="flex items-center">
        <app-button-atom
          [link]="urlButtonImage"
          class="mx-auto"
          [type]="'primary'"
          [color]="'primary'"
          [label]="labelButtonImage"
          [thickSize]="buttonSizeY"
        ></app-button-atom>
      </div>
    </div>
  </div>
  <div class="lg:w-4/12 pt-10 lg:pt-32 pb-16 lg:pb-32 px-12 bg-neutral-800 text-center">
    <div class="max-w-screen-sm mx-auto">
      <h2 class="mb-6 font-accent font-bold text-1xsl text-white">
        {{ textContent }}
      </h2>
      <app-block-list [blockIdList]="buttons"></app-block-list>
    </div>
  </div>
</div>
